const createArrayFromEnum = obj => {
    const array = [];

    for (const i in obj) {
        array.push({
            id: obj[i],
            value: i
        })
    }

    return array;
};

const arrayHasDuplicates = array => {
    return new Set(array).size !== array.length
};

const arrayContainsItemWithProperty = (array, propName, propValue) => {
    return array.some(item => item[propName] === propValue);
};

const sorter = (a, b, key) => {
    if (a[key] < b[key]) //sort string ascending
        return -1;
    if (a[key] > b[key])
        return 1;
    return 0;
};

export {createArrayFromEnum, arrayHasDuplicates, arrayContainsItemWithProperty, sorter}